export default "__VITE_ASSET__E1sE7eTN__"